import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "next/image";
export const ContentCollectionWorkspaceInformation = (param)=>{
    let { workspace } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        "data-testid": "CONTENT_COLLECTION_WORKSPACE_INFORMATION",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "relative size-8 overflow-hidden rounded bg-grey-3",
                children: /*#__PURE__*/ _jsx(Image, {
                    alt: "Logo for ".concat(workspace.name),
                    fill: true,
                    priority: true,
                    sizes: "64px",
                    src: workspace.image
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "truncate text-14 font-medium text-grey-11",
                "data-testid": "CONTENT_COLLECTION_WORKSPACE_INFORMATION_NAME",
                children: workspace.name
            })
        ]
    });
};
